module.exports = __webpack_public_path__ + "img/slide_5st_bg.c5052e3e.svg";